<template>
    <!--   Footer Start Here   -->
    <footer>
      <div class="container_large">
        <div class="row">
          <div class="col-md-5">
            <div class="footer_column">
              <div class="footer_logo mb-5"><img src="/src/assets/images/logo.png" alt=""></div>
              <p class="mb-4">
                <a href="#">
                  <svg xmlns="http://www.w3.org/2000/svg" width="28.982" height="28.982" viewBox="0 0 28.982 28.982">
                  <path id="Icon_open-location" data-name="Icon open-location" d="M28.982,0,0,14.491l10.868,3.623,3.623,10.868Z" fill="#9cabc4"/>
                </svg>
                <span>www.dirtydrawz.com</span>
                </a>
              </p>
              <p class="mb-4">
                <a href="mailto:info@dirtydrawz.com">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="27.891" viewBox="0 0 36 27.891">
                  <path id="Icon_simple-minutemailer" data-name="Icon simple-minutemailer" d="M8.346,4.055l5.175,5.6-3.651,7.2,7.71-1.382,3.51,8.469L36,4.389ZM7.392,16.187l1.435-1.181-1.851.585-.189-.27.765-.743-1,.4A10.217,10.217,0,0,0,3.2,31.945a10.145,10.145,0,0,1-1.327-5.032,10.472,10.472,0,0,1,6.472-9.63l.472-1.149-1.125.5L7.375,16.2l.016-.017Zm6.546-2.955L16.335,9l14.1-3.3L13.938,13.231Z" transform="translate(0 -4.055)" fill="#9cabc4"/>
                </svg>
                <span>info@dirtydrawz.com</span>
                </a>
              </p>
              <p>
                <a href="tel:877-973-DRAWZ">
                  <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27">
                    <path id="Icon_material-phone" data-name="Icon material-phone" d="M9.93,16.185a22.723,22.723,0,0,0,9.885,9.885l3.3-3.3a1.491,1.491,0,0,1,1.53-.36A17.11,17.11,0,0,0,30,23.265a1.5,1.5,0,0,1,1.5,1.5V30A1.5,1.5,0,0,1,30,31.5,25.5,25.5,0,0,1,4.5,6,1.5,1.5,0,0,1,6,4.5h5.25A1.5,1.5,0,0,1,12.75,6a17.041,17.041,0,0,0,.855,5.355,1.505,1.505,0,0,1-.375,1.53l-3.3,3.3Z" transform="translate(-4.5 -4.5)" fill="#9cabc4"/>
                  </svg>
                    <span>877-973-DRAWZ</span>
                </a>
              </p>
            </div>
          </div>
          <div class="col-6 col-md-2">
            <div class="footer_column">
              <h2>Quick Links</h2>
              <ul class="footer_list">
                <li><a href="/#how-we-works">How It Works</a></li>
                <li><a href="/#pricing">Pricing</a></li>
                <li><router-link :to="{name:'faqs'}">Faq's</router-link></li>
                <li><router-link :to="{name:'terms-and-conditions'}">Terms & Conditions</router-link></li>
              </ul>
            </div>
          </div>
          <div class="col-6 col-md-2">
            <div class="footer_column">
              <h2>Services</h2>
              <ul class="footer_list">
                <li><a href="#">Wash & Fold</a></li>
                <li><a href="#">Dry Cleaning</a></li>
                <li><a href="#">Tailoring</a></li>
              </ul>
            </div>
          </div>
          <div class="col-md-3">
            <div class="footer_column">
              <h2>Follow Us</h2>
              <ul class="footer_social">
                <li><a href="https://www.facebook.com/Dirtydrawzcom-Laundry-Service-667458779936377/" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                <li><a href="#" target="_blank"><i class="fab fa-twitter"></i></a></li>
                <li><a href="https://www.instagram.com/dirty_drawz/" target="_blank"><i class="fab fa-instagram"></i></a></li>
              </ul>
              <p>Mon-Fri: 8am-6pm</p>
              <p>Sat-Sun: 9am-5pm</p>
            </div>
          </div>
        </div>
        <div class="row pt-md-5">
          <div class="col-md-6">
            <div class="copyright">© Copyright 2021 Dirty Drawz</div>
          </div>
          <div class="col-md-6">
            <div class="payment_logos">
              <img src="/src/assets/images/master-logo.png" alt="">
              <img src="/src/assets/images/visa-logo.png" alt="">
              <img src="/src/assets/images/discover-logo.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </footer>
    <!--   Footer Ends Here   -->
</template>
<script>
export default {
  data(){
    return{
       facebook_link: null,
       instagram_link: null,
    }
  },
  watch: {
    '$store.state.socials': function (social_links) {
       if(social_links && social_links.length){
       social_links.forEach(element => {
        if(element.type=='instagram'){
          this.instagram_link = element.url;
        } else if(element.type=="facebook"){
          this.facebook_link = element.url;
        }
      });
    }
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/layouts/footer.vue